var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketballWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.33 93.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#010101;}.cls-4{fill:#fff;}.cls-5{fill:#daedd6;}.cls-6{fill:none;}.cls-6,.cls-2,.cls-7,.cls-8,.cls-3,.cls-9,.cls-10{stroke:#020202;}.cls-6,.cls-3,.cls-9,.cls-10{stroke-width:2px;}.cls-2,.cls-7,.cls-8{stroke-miterlimit:4;stroke-width:2px;}.cls-7{fill:#d9dad8;}.cls-8{fill:#4f4f4f;}.cls-9{fill:#f5ee73;}.cls-10{fill:#fcb022;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 13.51,
    y: 0.21,
    width: 131.67,
    height: 92.91,
    transform: "translate(.15 -.25) rotate(.18)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.45,
    y: 29.54,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.45,
    y: 30.54,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 20.45,
    y: 24.54,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 21.45,
    y: 25.54,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 99.55,
    y: 27.82,
    width: 6.32,
    height: 25.74,
    transform: "translate(19.96 113.88) rotate(-63.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 103.51,
    y: 46.3,
    width: 29.9,
    height: 6.32,
    transform: "translate(20.76 132.73) rotate(-63.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71.37,
    y: 29.99,
    width: 29.9,
    height: 6.32,
    transform: "translate(17.7 95.13) rotate(-63.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 117.41,
    y: 49.82,
    width: 13.25,
    height: 4.93,
    transform: "translate(21.29 139.25) rotate(-63.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.12,
    y: 27.86,
    width: 13.25,
    height: 4.93,
    transform: "translate(17.17 88.61) rotate(-63.1)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 97.55,
    y: 23.82,
    width: 6.32,
    height: 25.74,
    transform: "translate(22.42 109.91) rotate(-63.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 101.51,
    y: 42.3,
    width: 29.9,
    height: 6.32,
    transform: "translate(23.23 128.76) rotate(-63.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 69.36,
    y: 25.99,
    width: 29.9,
    height: 6.32,
    transform: "translate(20.17 91.15) rotate(-63.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 115.41,
    y: 45.82,
    width: 13.25,
    height: 4.93,
    transform: "translate(23.76 135.27) rotate(-63.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 72.12,
    y: 23.86,
    width: 13.25,
    height: 4.93,
    transform: "translate(19.64 84.64) rotate(-63.1)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.28,65.99c-4.21,12.43-18.05,19.04-30.96,14.66-12.91-4.37-19.89-18.03-15.68-30.46,4.21-12.43,18.05-19.04,30.96-14.67s19.89,18.03,15.68,30.46h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 49.84,
    y1: 35.91,
    x2: 34.95,
    y2: 79.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.4,64.82c10.37,1.82,22.88-19.64,8.73-25.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.95,77.2c-9.34-4.85-6.24-29.5,8.73-25.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 20.28,
    y1: 50.2,
    x2: 65.78,
    y2: 65.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M62.28,62.99c-4.21,12.43-18.05,19.04-30.96,14.66-12.9-4.37-19.88-18.02-15.67-30.45s18.05-19.04,30.96-14.67,19.89,18.03,15.68,30.46h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 45.84,
    y1: 32.91,
    x2: 30.95,
    y2: 76.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M16.4,61.82c10.37,1.82,22.88-19.64,8.73-25.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M52.95,74.2c-9.34-4.85-6.24-29.5,8.73-25.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 16.28,
    y1: 47.2,
    x2: 61.78,
    y2: 62.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.81,71.62l4.58,1.23c.74,.2,.82,1.22,.12,1.53l-4.33,1.94c-.44,.2-.61,.73-.37,1.15l2.37,4.11c.38,.66-.28,1.44-.99,1.17l-4.43-1.69c-.45-.17-.95,.08-1.08,.55l-1.23,4.58c-.2,.74-1.22,.82-1.53,.12l-1.94-4.33c-.2-.44-.73-.61-1.15-.37l-4.11,2.37c-.66,.38-1.44-.28-1.17-.99l1.69-4.43c.17-.45-.08-.95-.55-1.08l-4.58-1.23c-.74-.2-.82-1.22-.12-1.53l4.33-1.94c.44-.2,.61-.73,.37-1.15l-2.37-4.11c-.38-.66,.28-1.44,.99-1.17l4.43,1.69c.45,.17,.95-.08,1.08-.55l1.23-4.58c.2-.74,1.22-.82,1.53-.12l1.94,4.33c.2,.44,.73,.61,1.15,.37l4.11-2.37c.66-.38,1.44,.28,1.17,.99l-1.69,4.43c-.17,.45,.08,.95,.55,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.42,55.87l2.28,.61c.37,.1,.41,.61,.06,.76l-2.16,.96c-.22,.1-.31,.36-.19,.57l1.18,2.05c.19,.33-.14,.72-.5,.58l-2.21-.84c-.22-.09-.47,.04-.54,.27l-.61,2.28c-.1,.37-.61,.41-.76,.06l-.96-2.16c-.1-.22-.36-.31-.57-.19l-2.05,1.18c-.33,.19-.72-.14-.58-.5l.84-2.21c.09-.22-.04-.47-.27-.54l-2.28-.61c-.37-.1-.41-.61-.06-.76l2.16-.96c.22-.1,.31-.36,.19-.57l-1.18-2.05c-.19-.33,.14-.72,.5-.58l2.21,.84c.22,.09,.47-.04,.54-.27l.61-2.28c.1-.37,.61-.41,.76-.06l.96,2.16c.1,.22,.36,.31,.57,.19l2.05-1.18c.33-.19,.72,.14,.58,.5l-.84,2.21c-.09,.22,.04,.47,.27,.54Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M87.81,69.62l4.58,1.23c.74,.2,.82,1.22,.12,1.53l-4.33,1.94c-.44,.2-.61,.73-.37,1.15l2.37,4.11c.38,.66-.28,1.44-.99,1.17l-4.43-1.69c-.45-.17-.95,.08-1.08,.55l-1.23,4.58c-.2,.74-1.22,.82-1.53,.12l-1.94-4.33c-.2-.44-.73-.61-1.15-.37l-4.11,2.37c-.66,.38-1.44-.28-1.17-.99l1.69-4.43c.17-.45-.08-.95-.55-1.08l-4.58-1.23c-.74-.2-.82-1.22-.12-1.53l4.33-1.94c.44-.2,.61-.73,.37-1.15l-2.37-4.11c-.38-.66,.28-1.44,.99-1.17l4.43,1.69c.45,.17,.95-.08,1.08-.55l1.23-4.58c.2-.74,1.22-.82,1.53-.12l1.94,4.33c.2,.44,.73,.61,1.15,.37l4.11-2.37c.66-.38,1.44,.28,1.17,.99l-1.69,4.43c-.17,.45,.08,.95,.55,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M99.42,53.87l2.28,.61c.37,.1,.41,.61,.06,.76l-2.16,.96c-.22,.1-.31,.36-.19,.57l1.18,2.05c.19,.33-.14,.72-.5,.58l-2.21-.84c-.22-.09-.47,.04-.54,.27l-.61,2.28c-.1,.37-.61,.41-.76,.06l-.96-2.16c-.1-.22-.36-.31-.57-.19l-2.05,1.18c-.33,.19-.72-.14-.58-.5l.84-2.21c.09-.22-.04-.47-.27-.54l-2.28-.61c-.37-.1-.41-.61-.06-.76l2.16-.96c.22-.1,.31-.36,.19-.57l-1.18-2.05c-.19-.33,.14-.72,.5-.58l2.21,.84c.22,.09,.47-.04,.54-.27l.61-2.28c.1-.37,.61-.41,.76-.06l.96,2.16c.1,.22,.36,.31,.57,.19l2.05-1.18c.33-.19,.72,.14,.58,.5l-.84,2.21c-.09,.22,.04,.47,.27,.54Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketballWeb);
export default __webpack_public_path__ + "static/media/basketball_web.dd97d157b6697e696a134d37d78803b5.svg";
export { ForwardRef as ReactComponent };